import Cookies from 'js-cookie'

export const getUserId = () => Cookies.get('__app__userId__')
export const setUserId = (value: string) => {
  Cookies.set('__app__userId__', value, { domain: 'ijianshui.com', path: '', expires: 365 })
}
